module.exports = __webpack_public_path__ + "img/wsearcg.5175b487.png";